module.exports = __webpack_public_path__ + "static/media/timesheet_banner.ab1b0d7b.png";